import classNames from 'classnames';
import React from 'react';
import { Container } from './IconButton.styles';
import { HudIcon, type IconType } from '../../../Icons/HudIcons';

export const ICON_BUTTON_SKINS = [
  'default',
  'brand',
] as const;

export type IconButtonProps = {
  skin?: (typeof ICON_BUTTON_SKINS)[number];
  outline?: boolean;
  icon: IconType;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  disabled?: boolean;
  selectable?: boolean;
  'aria-label'?: string; // Required for accessibility since there's no visible text
};

const IconButton = React.forwardRef<HTMLButtonElement, IconButtonProps>(({
  skin = 'default',
  outline,
  icon,
  onClick,
  disabled,
  selectable = true,
  'aria-label': ariaLabel,
}, ref) => {

  return (
    <Container
      ref={ref}
      className={classNames(`skin_${skin}`, { outline, selectable })}
      onClick={onClick}
      disabled={disabled}
      aria-label={ariaLabel}
    >
      <HudIcon icon={icon} size="16px" />
    </Container>
  );
});

IconButton.displayName = 'IconButton';

export default IconButton;
